import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChallengeIconDark = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "100px",
	width: "100px",
	fill: "#474747",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	enableBackground: "new 0 0 100 100",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M71.601,20.783c-2.48,0-4.487,2.111-4.487,4.715v22.335h-2.096V18.423c0-2.604-2.009-4.714-4.487-4.714   c-2.479,0-4.485,2.11-4.485,4.714v29.411H53.95v-34.93c0-2.604-2.01-4.715-4.489-4.715c-2.477,0-4.485,2.11-4.485,4.715v34.93   h-2.097V18.423c0-2.604-2.01-4.714-4.487-4.714c-2.478,0-4.486,2.11-4.486,4.714v31.675v9.351v1.173l-6.193-9.461   c-1.35-2.185-4.128-2.806-6.208-1.387c-2.079,1.417-2.67,4.336-1.321,6.523c0,0,8.758,15.932,12.645,22.99   c3.724,6.328,11.954,12.003,20.504,12.003c13.653,0,22.169-9.983,22.169-22.317l0.587-21.138V25.499   C76.088,22.894,74.078,20.783,71.601,20.783z" }) })
});
export default SvgChallengeIconDark;
